var __s__ = require('./support-fns.js');
// var THREE = require('three');

//Class Jaw
export class Jaw {

    constructor(upper, jawScene) {
        let h;

        this.name = upper ? "upperJaw" : "lowerJaw";
        this.upper = !!upper;
        this._visible = true;
        this.teeth = {};
        this.scene = jawScene;

        //references by name
        this.teethByUNS = {};
        this.teethByFDI = {};

        //Meshes holder.
        this.group3D = new THREE.Group();
        this.group3D.name = "group_" + this.name;

        //Extra holder to rotate Jaws
        this.group3D.holder = new THREE.Group();
        this.group3D.add(this.group3D.holder);

        //Create Groups for labels
        this.group3D.labelsUns = new THREE.Group();
        this.group3D.labelsFdi = new THREE.Group();
        this.group3D.labelsLines = new THREE.Group();

        //Connectors
        this.group3D.connectorControls = new THREE.Group();

        //Attach them below holder
        this.group3D.holder.add(this.group3D.labelsUns);
        this.group3D.holder.add(this.group3D.labelsFdi);
        this.group3D.holder.add(this.group3D.labelsLines);
        this.group3D.holder.add(this.group3D.connectorControls);
    }

    get visible() { return this._visible; }
    set visible(v) {
        let me = this;
        this._visible = !!v;
        this.group3D.visible = this._visible;

        let ev = __s__.addEventDsptchr(me._visible ? "show" : "hide");
        me.scene._node.dispatchEvent(ev);
    }

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }

    reset() {
        for (var i in this.teethByUNS) {
          if (this.teethByUNS.hasOwnProperty(i)) {
            this.teethByUNS[i].reset();
          }
        }
    }

    _attachTooth(tooth) {
        this.teeth[tooth.name] = tooth;
        this.teethByUNS[String(tooth.numberUNS)] = tooth;
        this.teethByFDI[String(tooth.numberFDI)] = tooth;
        this.group3D.holder.add(tooth.object3D);
    }

    _attachMesh(mesh) {
        this.group3D.holder.add(mesh);
    }

}
